import classnames from 'classnames';
import { arrayOf, bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import { GoPencil } from 'react-icons/go';
import { Button } from 'reactstrap';

import AssociatedModelList from '../AssociatedModelList';
import getMappings from '../mappings';

function InactiveView({
  id,
  readOnly,
  type,
  isMulti,
  value,
  classNames,
  onToggleActive,
  ...rest
}) {
  const DetailView = getMappings()[type].view;
  return (
    <div className={classnames(classNames, 'd-flex')}>
      <div className="flex-grow-1 text-overflow--ellipsis lh-2">
        {isMulti ? (
          <AssociatedModelList type={type} ids={value} {...rest} />
        ) : (
          <DetailView id={value} {...rest} />
        )}
      </div>
      {!readOnly && (
        <Button
          onClick={onToggleActive}
          id={id}
          color="default"
          className="d-inline-block pt-0"
          size="sm"
        >
          <GoPencil />
        </Button>
      )}
    </div>
  );
}

InactiveView.propTypes = {
  id: string, // so that this can be a label target
  readOnly: bool,
  isMulti: bool,
  classNames: string,
  type: string.isRequired,
  value: oneOfType([arrayOf(number.isRequired), number, string]),
  onToggleActive: func.isRequired,
};

InactiveView.defaultProps = {
  id: undefined,
  readOnly: false,
  isMulti: false,
  classNames: '',
  value: undefined,
};

export default InactiveView;
